import * as React from 'react'
import { memo } from 'react'
const SvgArrowLeft = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 6">
    <path d="M24 2.64 5.28 2.52A3.9 3.9 0 0 0 6.36 0 16.5 16.5 0 0 1 0 3a15.7 15.7 0 0 1 6.36 3 4.1 4.1 0 0 0-1.2-2.52L24 3.6Z" />
  </svg>
)
const Memo = memo(SvgArrowLeft)
export default Memo
